'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _widgets = require('redux/modules/widgets');

var widgetActions = _interopRequireWildcard(_widgets);

var _reduxForm = require('redux-form');

var _components = require('components');

var _reduxConnect = require('redux-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Widgets = (_dec = (0, _reduxConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _widgets.isLoaded)(getState())) {
      return dispatch((0, _widgets.load)());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    widgets: state.widgets.data,
    editing: state.widgets.editing,
    error: state.widgets.error,
    loading: state.widgets.loading
  };
}, (0, _extends3.default)({}, widgetActions, { initializeWithKey: _reduxForm.initializeWithKey })), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Widgets, _Component);

  function Widgets() {
    (0, _classCallCheck3.default)(this, Widgets);
    return (0, _possibleConstructorReturn3.default)(this, (Widgets.__proto__ || (0, _getPrototypeOf2.default)(Widgets)).apply(this, arguments));
  }

  (0, _createClass3.default)(Widgets, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var handleEdit = function handleEdit(widget) {
        var editStart = _this2.props.editStart; // eslint-disable-line no-shadow

        return function () {
          return editStart(String(widget.id));
        };
      };
      var _props = this.props,
          widgets = _props.widgets,
          error = _props.error,
          editing = _props.editing,
          loading = _props.loading,
          load = _props.load;

      var refreshClassName = 'fa fa-refresh';
      if (loading) {
        refreshClassName += ' fa-spin';
      }
      var styles = require('./Widgets.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.widgets + ' container' },
        _react2.default.createElement(
          'h1',
          null,
          'Widgets',
          _react2.default.createElement(
            'button',
            { className: styles.refreshBtn + ' btn btn-success', onClick: load },
            _react2.default.createElement('i', { className: refreshClassName }),
            ' ',
            ' ',
            ' Reload Widgets'
          )
        ),
        _react2.default.createElement(_reactHelmet2.default, { title: 'Widgets' }),
        _react2.default.createElement(
          'p',
          null,
          'If you hit refresh on your browser, the data loading will take place on the server before the page is returned. If you navigated here from another page, the data was fetched from the client after the route transition. This uses the decorator method ',
          _react2.default.createElement(
            'code',
            null,
            '@asyncConnect'
          ),
          ' with the ',
          _react2.default.createElement(
            'code',
            null,
            'deferred: true'
          ),
          ' flag. To block a route transition until some data is loaded, remove the ',
          _react2.default.createElement(
            'code',
            null,
            'deffered: true'
          ),
          ' flag. To always render before loading data, even on the server, use ',
          _react2.default.createElement(
            'code',
            null,
            'componentDidMount'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'This widgets are stored in your session, so feel free to edit it and refresh.'
        ),
        error && _react2.default.createElement(
          'div',
          { className: 'alert alert-danger', role: 'alert' },
          _react2.default.createElement('span', { className: 'glyphicon glyphicon-exclamation-sign', 'aria-hidden': 'true' }),
          ' ',
          error
        ),
        widgets && widgets.length && _react2.default.createElement(
          'table',
          { className: 'table table-striped' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { className: styles.idCol },
                'ID'
              ),
              _react2.default.createElement(
                'th',
                { className: styles.colorCol },
                'Color'
              ),
              _react2.default.createElement(
                'th',
                { className: styles.sprocketsCol },
                'Sprockets'
              ),
              _react2.default.createElement(
                'th',
                { className: styles.ownerCol },
                'Owner'
              ),
              _react2.default.createElement('th', { className: styles.buttonCol })
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            widgets.map(function (widget) {
              return editing[widget.id] ? _react2.default.createElement(_components.WidgetForm, { formKey: String(widget.id), key: String(widget.id), initialValues: widget }) : _react2.default.createElement(
                'tr',
                { key: widget.id },
                _react2.default.createElement(
                  'td',
                  { className: styles.idCol },
                  widget.id
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.colorCol },
                  widget.color
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.sprocketsCol },
                  widget.sprocketCount
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.ownerCol },
                  widget.owner
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.buttonCol },
                  _react2.default.createElement(
                    'button',
                    { className: 'btn btn-primary', onClick: handleEdit(widget) },
                    _react2.default.createElement('i', { className: 'fa fa-pencil' }),
                    ' Edit'
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return Widgets;
}(_react.Component), _class2.propTypes = {
  widgets: _react.PropTypes.array,
  error: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  initializeWithKey: _react.PropTypes.func.isRequired,
  editing: _react.PropTypes.object.isRequired,
  load: _react.PropTypes.func.isRequired,
  editStart: _react.PropTypes.func.isRequired
}, _temp)) || _class) || _class);
exports.default = Widgets;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Widgets/Widgets.js
// module id = 1290
// module chunks = 0